import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-violation-count',
  templateUrl: './violation-count.component.html',
  styleUrls: ['./violation-count.component.scss'],
})
export class ViolationCountComponent {
  @Input() public color: 'red' | 'yellow' | 'orange';
  @Input() public value: number;
  @Input() public linkable = false;
}
